<div class="brand p-l-15 p-r-15">
  <a (click)="redirect()" *ngIf="!this.customizer.dark">
    <img src="assets/images/logos/logo-white.png" alt="logo" />
  </a>
  <a (click)="redirect()" *ngIf="this.customizer.dark">
    <img src="assets/images/logos/logo-white.png" alt="logo" />
  </a>
</div>